// export const api = 'https://admin.staging.mysenscare.com'
export const api = 'https://admin.stage.mysenscare.com'


// https://admin.senscare.sdsstaging.co.uk
// https://admin.staging.mysenscare.com
// https://senscare.sdsstaging.co.uk/search-parents